// Development helper: fill the forms on screen with plausible data so a flow
// can be walked through in seconds. CLIENT SIDE ONLY — nothing is saved; the
// keeper still confirms, saves and signs exactly as they would in a real match.
// The buttons that call this are rendered in development and test only.
//
// Its bigger sibling is DevMatchSeeder ("DEV: testna tekma"), which creates a
// whole signed match in the database. This one is for testing the screens
// themselves — what is enabled when, what validates, what locks.
//
// Everyone is filled in as "NIMA licence" (or "Brez ...") on purpose: that is
// the branch with editable name fields, so no licence has to be looked up
// against the live licensing APIs just to get through the screen.

global.devFill = {
  // side -> role -> [first name, last name]
  STAFF: {
    scorekeeper: ['Zapisnikar', 'Prvi'],
    scorekeeper_assistant: ['Zapisnikar', 'Drugi'],
    timekeeper: ['Časomerilec', 'Prvi'],
    timekeeper_assistant: ['Merilec', 'Napada']
  },
  OFFICIALS: {
    referee1: ['Sodnik', 'Ena'],
    referee2: ['Sodnik', 'Dva'],
    referee3: ['Sodnik', 'Tri'],
    commissioner: ['Komisar', 'Prvi']
  },
  BENCH: {
    coach: ['Trener'],
    assistant: ['Pomočnik']
  },
  STATISTICIANS: ['statistician1', 'statistician2'],

  // matches#edit — the prematch screen
  preMatch: function() {
    for(var role in devFill.STAFF) {
      devFill.withoutLicense(context.assistant_referees[role], devFill.STAFF[role][0], devFill.STAFF[role][1]);
    }

    // nobody keeps statistics on a test match: "Brez statistika", confirmed,
    // so they are simply out of the way
    for(var statistician of devFill.STATISTICIANS) {
      var entry = context.statisticians[statistician];
      if(!entry) continue;

      entry.status = 'missing';
      entry.confirmed = 'confirmed';
    }

    for(var official in devFill.OFFICIALS) {
      var person = devFill.OFFICIALS[official];
      var referee = context.referees[official];
      referee.status = 'MANUAL_CUSTOM';   // "Ročno", so no licence API call
      referee.first_name = person[0];
      referee.last_name = person[1];
      referee.city = 'Ljubljana';
      delete referee.confirmed;
    }

    for(var side of ['home', 'away']) {
      var team = side === 'home' ? 'Domači' : 'Gostje';
      for(var member in devFill.BENCH) {
        devFill.withoutLicense(context[side][member], devFill.BENCH[member][0], team);
      }
      // "Brez predstavnika" — one less thing to fill in
      if(context[side].representative) {
        context[side].representative.status = 'missing';
        delete context[side].representative.confirmed;
      }
      devFill.fillRoster(side);
    }
    refreshContext();
  },

  // Name only, no licence — and never `confirmed`: confirming is the thing
  // being tested, and it is what locks the roster and asks the coach to sign.
  withoutLicense: function(entry, firstName, lastName) {
    if(!entry) return;

    entry.status = 'without_license';
    entry.first_name = firstName;
    entry.last_name = lastName;
    delete entry.license_number;
    delete entry.confirmed;
  },

  fillRoster: function(side) {
    var players = (context[side] || {}).players || [];
    if(players.length === 0) return;   // an FMS roster that has not loaded yet

    var youngest = preMatch.data.startingGroupSize === 4;
    var listed = Math.min(players.length, youngest ? 8 : 12);
    for(var i = 0; i < players.length; i++) {
      var player = players[i];
      var on = i < listed;
      player.number = on ? String(i + 4) : '';
      // manual matches come with blank placeholder players, so give them names;
      // an FMS roster already has real ones and must keep them
      if(!player.first_name) player.first_name = 'Igralec';
      if(!player.last_name) player.last_name = 'P' + (i + 4);
      player.in_lineup = youngest ? false : on;
      player.in_a = youngest && i < 4;
      player.in_b = youngest && i >= 4 && i < 8;
      player.is_starting = i < preMatch.data.startingGroupSize;
      player.is_captain = i === 0;
    }
  },

  // matches#new — the first page of a manual match
  customMatch: function() {
    context.manual_competition_name = 'DEV testna liga';
    context.sport_hall = { name: 'DEV dvorana' };
    context.first_team = { team: { name: 'DEV Domači' } };
    context.second_team = { team: { name: 'DEV Gostje' } };
    context.competition_gender = 'Moški';
    context.competition_category = 'Člani';
    context.competition_rank = '1';
    context.report_emails = 'dev@example.com';
    context.manual_phase_name = 'Redni del';
    context.round_number = '1';
    context.match_time_d = moment();
    context.date_time = context.match_time_d.format();
    refreshContext();
    $('.single-date-picker').val(context.formatted_match_time());
  }
};
